"use client";
import { jsx } from "react/jsx-runtime";
import { getImageSlideProps } from "../Carousel.js";
function HeroSlide({ ariaLabel, children, isSelected = false, index = 0, className }) {
    const { inertProps, tabIndexProps } = getImageSlideProps(isSelected);
    return /*#__PURE__*/ jsx("li", {
        className: className,
        "aria-hidden": !isSelected,
        "aria-label": ariaLabel ?? `Slide ${index + 1}`,
        ...inertProps,
        ...tabIndexProps,
        children: children
    });
}
HeroSlide.displayName = 'Carousel.HeroSlide';
export { HeroSlide };
